import { useMemo } from 'react';

import { OfferingDetails_PublishedOffering_SyndicateFragment } from '../../offering-side-panel/offering-details/graphql/__generated__';

export function useManagerResponsibilities(
  syndicate: OfferingDetails_PublishedOffering_SyndicateFragment | null
) {
  const { managers = [], managerResponsibilities = {} } = syndicate ?? {};

  return useMemo(
    () => ({
      leftLead: managers.find(
        ({ cmgEntityKey }) => cmgEntityKey === managerResponsibilities.leftLead
      )?.firmName,
      settlementAgent: managers.find(
        ({ cmgEntityKey }) => cmgEntityKey === managerResponsibilities.settlementAgent
      )?.firmName,
      stabilizationAgent: managers.find(
        ({ cmgEntityKey }) => cmgEntityKey === managerResponsibilities.stabilizationAgent
      )?.firmName,
      logisticsAgent: managers.find(
        ({ cmgEntityKey }) => cmgEntityKey === managerResponsibilities.logisticsAgent
      )?.firmName,
    }),
    [managerResponsibilities, managers]
  );
}
